module.exports = __webpack_public_path__ + "static/media/badge-success.50c8a84f.svg";